export default "__VITE_ASSET__SaSlSzQX__"